export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CATEGORIES_OPTIONS = "SET_CATEGORIES_OPTIONS";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const REFRESH_CATEGORIES = "REFRESH_CATEGORIES";